import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class CustomModalBody extends React.Component {
    render() {
        return (
            <form className="units">
                <div className="units__block">
                    <div className={(!this.props.validationDate.status) ? "units__date" : "units__date has-error"}>
                        <label className="date-title">Date</label>
                        <span className="kr kr-calendar" />
                        <DatePicker
                            dateFormat="DD/MM/YYYY"
                            className="form-control"
                            disabled={!this.props.changed}
                            selected={this.props.startDate}
                            onChange={this.props.handleDateChange}
                            minDate={moment()}
                        />
                        <span className='error-message'>{this.props.validationDate.message}</span>
                    </div>
                </div>
                <div className="units__block">
                    <p className="units__subtitle">Number of units</p>
                    <div className="units__number">
                        <div
                            className={(!this.props.validationNumberZyrconia.status) ? "text-field" : "text-field has-error"}
                        >
                            <label className="text-field__label" htmlFor="">Zirconia
                                <small> (Already booked {this.props.numberOfUnits.zirconia})</small></label>
                            <input
                                className="text-field__input"
                                type="number"
                                value={this.props.units_for_zirconia}
                                placeholder="Number of units"
                                onChange={(e) => this.props.handelChange('units_for_zirconia', e.target.value)}
                            />
                            <span className="error-message">{this.props.validationNumberZyrconia.message}</span>
                        </div>
                        <div
                            className={(!this.props.validationNumber.status) ? "text-field" : "text-field has-error"}
                        >
                            <label className="text-field__label" htmlFor="">Misc
                                <small> (Already booked {this.props.numberOfUnits.misc})</small></label>
                            <input
                                className="text-field__input"
                                type="number"
                                value={this.props.inputNumberOfUnits}
                                placeholder="Number of units"
                                onChange={(e) => this.props.handelChange('inputNumberOfUnits', e.target.value)}
                            />
                            <span className="error-message">{this.props.validationNumber.message}</span>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default CustomModalBody;


// WEBPACK FOOTER //
// ./src/components/AvailableUnits/addNewUnits.js